import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { QuickBooksStatus } from '@/types/settings';

export function useQuickBooksStatus() {
  return useApiQuery<QuickBooksStatus>({
    queryKey: settingsKeys.quickbooks(),
    queryFn: () => apiGet<QuickBooksStatus>(operationsClient, settingsEndpoints.qbStatus()),
    showErrorToast: false,
  });
}
